module.exports = __webpack_public_path__ + "img/je.62999e4b.svg";